var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table__link-list gap-xxs"},[_c('router-link',{staticClass:"link link--no-line",attrs:{"target":"_blank","to":{ name: _vm.routerData.pageName, params: _vm.getLinkParams() }}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }